import type { LocationDevice } from "app/pages/digital-marketing/keywords-campaigns/shared/types";
import { EDeviceType } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export const DEVICE_LABEL_KEYS: Record<LocationDevice, string> = {
    BOTH: "rankTracker.addKeywords.modal.allDevices",
    DESKTOP: "rankTracker.addKeywords.modal.desktop",
    MOBILE: "rankTracker.addKeywords.modal.mobile",
};

export const URL_DEVICE_TO_LOCATION_DEVICE: Record<string, LocationDevice> = {
    [EDeviceType.DESKTOP]: "DESKTOP",
    [EDeviceType.MOBILE]: "MOBILE",
};

export const TRACKING_EVENT_NAME = "Add Keywords Modal";
